const StepIntro = 0;
const StepPrompt = 1;
const StepTOC = 2;
const StepScript = 3;
const StepSlide = 4;

export const Steps = {
  StepIntro,
  StepPrompt,
  StepTOC,
  StepScript,
  StepSlide,
};

function NewSlideSteps({ step, setStep }) {
  return (
    <div className="flex justify-center">
      <ul className="steps">
        <li className={`step cursor-pointer ${step >= StepPrompt ? "step-primary" : ""}`} onClick={() => setStep(Steps.StepPrompt)}>
          <button className="mx-4 md:mx-10">
            Topic
          </button>
        </li>
        <li className={`step cursor-pointer ${step >= StepTOC ? "step-primary" : ""}`} onClick={() => setStep(Steps.StepTOC)}>
          <button className="mx-4 md:mx-10">
            Outline
          </button>
        </li>
        <li className={`step cursor-pointer ${step >= StepScript ? "step-primary" : ""}`} onClick={() => setStep(Steps.StepScript)}>
          <button className="mx-4 md:mx-10">
            Notes
          </button>
        </li>
        <li className={`step cursor-pointer ${step >= StepSlide ? "step-primary" : ""}`} onClick={() => setStep(Steps.StepSlide)}>
          <button className="mx-4 md:mx-10">
            Slides
          </button>
        </li>
      </ul>
    </div>
  );
}

export default NewSlideSteps;
